window.addEventListener("DOMContentLoaded", (event) => {
    // Wrapping all submenu items in a level 4 heading
    // const submenuItems = document.querySelectorAll(".navigation_submenu-item");
    //
    // submenuItems.forEach((item) => {
    //     const anchorTag = item.querySelector("a");
    //     if (anchorTag) {
    //         const h4Tag = document.createElement("h4");
    //         h4Tag.appendChild(anchorTag.cloneNode(true));
    //         item.innerHTML = "";
    //         item.appendChild(h4Tag);
    //     }
    // });
});